// ================================
// CARD SMART ROUTER
// The single landing point for every card QR scan — reachable by ANY phone
// camera (it's a real URL now, not a custom scheme only our own app
// understands). Checks the card's current state and sends the scanner
// wherever makes sense: not-yet-assigned, needs activation, or straight to
// sign-in for an already-activated member.
// ================================
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function CardRouter() {
  const { mid } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('checking'); // checking | not-found | unclaimed | suspended | error

  useEffect(() => {
    axios.get(`/api/members/card/${encodeURIComponent(mid)}/status`)
      .then(res => {
        const data = res.data;
        if (!data.exists) { setState('not-found'); return; }
        if (data.status === 'unclaimed') { setState('unclaimed'); return; }
        if (data.status === 'suspended') { setState('suspended'); return; }
        if (data.activated) navigate(`/login?mid=${encodeURIComponent(mid)}`, { replace: true });
        else navigate(`/activate?mid=${encodeURIComponent(mid)}`, { replace: true });
      })
      .catch(() => setState('error'));
  }, [mid, navigate]);

  const messages = {
    checking:   null,
    'not-found': "This card isn't recognized. If you think that's wrong, contact Weedo World.",
    unclaimed:  "This card hasn't been assigned to a member yet — check with Weedo World staff.",
    suspended:  'This account has been suspended. Contact support for help.',
    error:      "Something went wrong reading this card. Try again in a moment."
  };

  return (
    <div className="app-shell" style={{ padding:28, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'100vh', textAlign:'center' }}>
      {state === 'checking' ? (
        <p style={{ fontSize:14, color:'#3a5a8a' }}>Checking your card…</p>
      ) : (
        <>
          <h2 style={{ fontFamily:'Bebas Neue, sans-serif', fontSize:26, letterSpacing:2, marginBottom:10 }}>Weedo World</h2>
          <p style={{ fontSize:14, color:'#3a5a8a', maxWidth:280 }}>{messages[state]}</p>
        </>
      )}
    </div>
  );
}
